import zod from 'zod';

export const StreamServersSchemas = {
    ServerFarmDetail: zod.object({
        id: zod.coerce.number(),
    }),
    ServerFarms: zod.object({}),
};
